import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import SimpleCalc from './SimpleCalc';

import SimpleCalcClass from './SimpleCalcClass';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<SimpleCalcClass />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
